import { API_PATH } from '../../config';

const getGoogleElevation = async (elevator, coordinate) => new Promise(
    (resolve) => {
      try {
        elevator.getElevationForLocations(
            { locations: [coordinate] },
            (results, status) => {
              if (status !== 'OK') {
                resolve(0);
                return;
              }

              if (!results.length) {
                resolve(0);
                return;
              }

              resolve(results[0].elevation < 0 ? 0 : results[0].elevation);
            },
        );
      } catch (e) {
        resolve(0);
      }
    },
);

const getCoastalDEMElevation = async (coordinate) => fetch(
    `${API_PATH}/elevation/at`,
    {
      method: 'POST',
      body: JSON.stringify({
        coordinate,
      }),
      headers: {
        'Content-Type': 'application/json',
      },
    },
)
    .then((result) => result && result.json && result.json())
    .then((result) => result.elevation);

/**
 * Get elvevation of a location
 *
 * @param {elevator} elevator, Instantiated elevation service
 * @param {coordinate} coordinate, The center of the area to query
 *
 * @return {Promise<number>} elevation in meters
 */
export default async (
  elevator,
  coordinate,
) => Promise.all([
  getGoogleElevation(elevator, coordinate),
  getCoastalDEMElevation(coordinate),
]).then((elevations) => {
  if (elevations[1] > 0 && elevations[1] < elevations[0]) {
    return elevations[1];
  }

  return elevations[0];
});
